<template>
  <fieldset class="debt-plan" :disabled="busy">
    <legend>Čo sa stane s úverom?</legend>

    <div class="debt-plan-options" role="group" aria-label="Plán existujúceho úveru">
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        class="debt-plan-option"
        :class="{active: value === option.value}"
        :aria-pressed="value === option.value ? 'true' : 'false'"
        :title="option.note"
        :disabled="busy"
        @click="$emit('change', option.value)"
      >
        <app-icon :name="option.icon" :size="16" />
        <span>{{ option.label }}</span>
      </button>
    </div>

    <div class="debt-plan-note" aria-live="polite">
      {{ busy ? "Ukladám zmenu…" : selectedNote }}
    </div>
  </fieldset>
</template>

<script>
import AppIcon from "@/components/shared/AppIcon.vue";

const DEBT_PLAN_OPTIONS = Object.freeze([
  {
    value: "keep",
    label: "Ponechať",
    icon: "clock",
    note: "Splátka zostáva započítaná do limitov.",
  },
  {
    value: "repay",
    label: "Splatiť",
    icon: "check",
    note: "Úver sa splatí z vlastných zdrojov pred čerpaním.",
  },
  {
    value: "refinance",
    label: "Refinancovať",
    icon: "repeat",
    note: "Zostatok sa splatí novou hypotékou.",
  },
]);

export default {
  name: "DebtPlanSelector",
  components: {AppIcon},
  props: {
    value: {
      type: String,
      default: null,
    },
    busy: Boolean,
  },
  data: () => ({
    options: DEBT_PLAN_OPTIONS,
  }),
  computed: {
    selectedNote () {
      const selected = this.options.find((option) => option.value === this.value);
      return selected
        ? selected.note
        : "Vyberte, či sa úver ponechá, splatí pred čerpaním alebo refinancuje.";
    },
  },
};
</script>

<style scoped lang="scss">
.debt-plan {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.debt-plan legend {
  margin-bottom: 6px;
  padding: 0;
  color: var(--app-text-muted);
  font-size: 10px;
  font-weight: 800;
  line-height: 1.2;
}

.debt-plan-options {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 6px;
}

.debt-plan-option {
  display: inline-flex;
  min-width: 0;
  min-height: 40px;
  padding: 7px 11px;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  border: 1px solid var(--app-border);
  border-radius: 10px;
  background: var(--app-surface-muted);
  color: var(--app-text-muted);
  font-size: 11px;
  font-weight: 800;
  line-height: 1.15;
  cursor: pointer;
  transition: border-color .18s ease, background-color .18s ease, color .18s ease, transform .18s ease;
}

.debt-plan-option span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.debt-plan-option:hover:not(:disabled),
.debt-plan-option:focus-visible {
  border-color: var(--app-primary);
  color: var(--app-primary);
  outline: none;
  transform: translateY(-1px);
}

.debt-plan-option.active {
  border-color: var(--app-primary);
  background: var(--app-primary-soft);
  color: var(--app-primary);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--app-primary) 20%, transparent);
}

.debt-plan-option:disabled {
  cursor: wait;
  opacity: .68;
  transform: none;
}

.debt-plan-note {
  min-height: 16px;
  margin-top: 6px;
  color: var(--app-text-muted);
  font-size: 10px;
  font-weight: 500;
  line-height: 1.35;
}

@media (max-width: 480px) {
  .debt-plan-option {
    min-height: 42px;
    padding: 7px 10px;
    flex-direction: row;
    gap: 8px;
    font-size: 10px;
  }
}
</style>
